/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPregnancyCase } from 'app/shared/model/pregnancy-case.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { DeliveryType } from 'app/shared/model/enumerations/delivery-type.model';
import { PregnancyResult } from 'app/shared/model/enumerations/pregnancy-result.model';

export interface IObstetricEvent {
  id?: string;
  pregnancyConfirmedDate?: number | null;
  lengthOfPregnancy?: number | null;
  dandc?: string | null;
  childGender?: keyof typeof Gender | null;
  childWeight?: number | null;
  complications?: string | null;
  deliveryType?: keyof typeof DeliveryType | null;
  eventType?: keyof typeof PregnancyResult | null;
  labourStartDate?: number | null;
  lenghtOfLabor?: number | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  expose?: boolean | null;
  consentTaken?: boolean | null;
  patient?: IGlucoUser | null;
  pregnancy?: IPregnancyCase | null;
}

export const defaultValue: Readonly<IObstetricEvent> = {
  active: false,
  draft: false,
  expose: false,
  consentTaken: false,
};
